import { useEffect, useState } from "react"
import { observer } from "mobx-react"
import { Form, Slider, Typography, Button } from "antd"
import { useStore } from "stores/utils/use-store"
import { notifications } from "notifications"
import type { SocketsConfigType } from "domains/managingJson/store/types"

const { Title } = Typography

export const SocketsConfig = observer(() => {
  const { dataStore: { managingJsonStore } } = useStore()

  const [form] = Form.useForm<SocketsConfigType>()
  const [configData, setConfigData] = useState<SocketsConfigType | undefined>()

  useEffect(() => {
    managingJsonStore.getData()
  }, [managingJsonStore])

  useEffect(() => {
    const socketsConfigItem = managingJsonStore.itemTypes?.find(item => item.type === "socketsConfig")
    if (socketsConfigItem) {
      const data = socketsConfigItem.data as SocketsConfigType
      setConfigData(data)
      form.setFieldsValue(data)
    }
  }, [managingJsonStore.itemTypes, form])

  const onFinishHandler = async() => {
    const { newServicePercentage } = await form.validateFields()

    managingJsonStore.funcAfterSuccess = async() => {
      notifications.success("Saved successfully")
      await managingJsonStore.getData()
    }

    const config = {
      name: "socketsConfig",
      type: "socketsConfig",
      data: { newServicePercentage },
    } as const

    if (configData) {
      await managingJsonStore.update(config)
    } else {
      await managingJsonStore.create(config)
    }
  }

  return (
    <Form form={form} onFinish={onFinishHandler} layout="vertical" style={{ maxWidth: 600 }}>
      <Title level={2}>Sockets Routing Configuration</Title>

      <Form.Item
        label="Percentage of traffic routed to the NEW sockets service"
        name="newServicePercentage"
        rules={[{ required: true, message: "Please select percentage" }]}
      >
        <Slider
          min={0}
          max={100}
          marks={{ 0: "0%", 25: "25%", 50: "50%", 75: "75%", 100: "100%" }}
          tooltip={{ formatter: (value: number | undefined) => `${value ?? 0}%` }}
        />
      </Form.Item>

      <Button type="primary" htmlType="submit">Save</Button>
    </Form>
  )
})
